import React, { useMemo } from 'react';
import { useParams, Link } from 'react-router-dom';
import './GamePlayPage.css';
import Logo from '../components/Logo';
import { useGame, buildGameUrl } from '../hooks/useGames';

function PlayNav({ gameName }) {
  return (
    <nav className="play-nav">
      <div className="play-nav-inner">
        <Link className="site-logo" to="/" aria-label="Go to home page">
          <Logo size={32} idPrefix="play-nav" />
          <span className="site-logo-text">Sunsoft<span className="site-logo-accent">Gaming</span></span>
        </Link>
        <h1 className="play-nav-title">{gameName}</h1>
        <Link className="play-nav-back" to="/games">Back to Games</Link>
      </div>
    </nav>
  );
}

export default function GamePlayPage() {
  const { slug } = useParams();
  const { game, loading, error } = useGame(slug);
  const gameUrl = useMemo(() => (game ? buildGameUrl(game) : null), [game]);

  return (
    <div className="game-play-root">
      <PlayNav gameName={game?.name} />

      <div className="game-play-frame-wrap">
        {loading && (
          <div className="demo-state">
            <div className="demo-spinner" />
            <p>Loading game…</p>
          </div>
        )}

        {error && (
          <div className="demo-state demo-error">
            <p>Could not load game: {error}</p>
            <Link className="btn-ghost" to="/games">Back to Games</Link>
          </div>
        )}

        {!loading && !error && gameUrl && (
          <iframe
            className="game-play-iframe"
            src={gameUrl}
            title={game?.name || 'Game'}
            allow="fullscreen"
            allowFullScreen
          />
        )}
      </div>
    </div>
  );
}
